import { defineLanguage } from "../registry";

export default defineLanguage({ id: "tsx", runner: "javascript" });
